export default __webpack_public_path__ + "static/media/visa_logo.a05453b4.png";